import {ObjectCheckerService} from '../../../../../services/object-checker.service';

declare let THREE: any;
import {DragBehaviorBase} from '../drag-behavior-base';
import {Injectable} from '@angular/core';
import {CollisionService} from '../../../../../services/collision/collision.service';
import {StageService} from '../../../../../services/stage.service';

class FloorObjectDragBehaviour extends DragBehaviorBase {

  clickPoint: any;
  objectsViolation: any;
  objectsOffset: any;
  floors: Array<any> = [];

  constructor(
    private handler,
    private objectCheckerSrvc: ObjectCheckerService,
    private collisionSrvc: CollisionService,
    private StageSrvc: StageService
  ) {
    super(handler);
    this.clickPoint = new THREE.Vector3();
    this.objectsViolation = {};
    this.objectsOffset = {};
  }

  canExecute(selected) {
    let i = 0;
    let obj;
    for (; i < selected.length; i++) {
      obj = selected[i];
      if (
        this.objectCheckerSrvc.isWallEmbeddable(obj) ||
        this.objectCheckerSrvc.isWallMountable(obj) ||
        this.objectCheckerSrvc.isFloor(obj) ||
        this.objectCheckerSrvc.isWall(obj)
      ) {
        return false;
      }
    }
    return true;
  }

  hold(e) {
    this.floors = [...this.StageSrvc.getCompoundFloor().children, this.StageSrvc.getGround()];
    const intersections = e.raycaster.intersectObjects(this.floors);
    this.clickPoint.copy(intersections[0].point);
    super.hold(e);
  }

  move(e, transformation) {

    const draggedObject = e.draggedObject;
    const draggedObjectId = draggedObject.id;
    const objectsOffset = this.objectsOffset;

    objectsOffset[draggedObjectId] = objectsOffset[draggedObjectId] ||
      this.clickPoint.clone().sub(transformation.position);

    const intersections = e.raycaster.intersectObjects(this.floors);

    transformation.position = intersections ?
      intersections[0].point.sub(objectsOffset[draggedObjectId]) : transformation.position;

    super.move(e, transformation);

    // const outOfRoomBounds = !this._insideRoomChecker.check(transformation.position);
    const collided = this.collisionSrvc.isCollide(draggedObject, e.staticObjects, {
      newPosition: transformation.position,
      newRotation: transformation.rotation
    });

    this.objectsViolation[draggedObject.id] = // outOfRoomBounds ||
      !!collided;

    const hasViolation = Object.values(this.objectsViolation).indexOf(true) !== -1;

    if (hasViolation) {
      transformation.copy(e.draggedObjectWorldTransform);
    }
  }

  release(e) {
    this.objectsViolation = {};
    this.objectsOffset = {};
    super.release(e);
  }

  getStaticObjectsFilter(objects): (obj) => boolean {
    return (obj) => obj.visible
      && objects.indexOf(obj) === -1
      && !this.objectCheckerSrvc.isFloor(obj)
      && (this.objectCheckerSrvc.isAccessory(obj) || this.objectCheckerSrvc.isWall(obj));
  }

}

@Injectable()
export class FloorObjectDragBehaviourFactory {

  constructor(
    private objectCheckerSrvc: ObjectCheckerService,
    private collisionSrvc: CollisionService,
    private StageSrvc: StageService
  ) {
  }

  create(handler): DragBehaviorBase {
    return new FloorObjectDragBehaviour(
      handler,
      this.objectCheckerSrvc,
      this.collisionSrvc,
      this.StageSrvc
    );
  }
}




// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/Drag/Behavior/FloorObject/floor-object-drag.ts